'use client';

const BrandDivider = ({ align = 'center' }) => {
  return (
    <div
      className={`tw-h-1 tw-w-12 tw-block tw-mt-6 ${
        align === 'left'
          ? 'tw-mr-auto tw-ml-0'
          : align === 'right'
            ? 'tw-ml-auto tw-mr-0'
            : 'tw-mx-auto'
      } tw-bg-brand-300`}
    />
  );
};

export default BrandDivider;
